@if (_userSig(); as user) {
  <div class="ac-manager link-s" [matMenuTriggerFor]="menu">{{ user.fullName | initials }}</div>
  <mat-menu #menu="matMenu" xPosition="before" class="!max-w-none !rounded-none border border-solid border-neutral-black">
    <ac-profile-info [user]="user" />
  </mat-menu>
} @else if (_isAuthenticated$ | async) {
  <div class="ac-manager" role="button" (click)="_logout()" (keydown.enter)="_logout()" (keydown.space)="_logout()">
    <ac-icon name="sign-out" size="small" />
  </div>
}
